import '@/assets/main.css'

import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { shimmerConfigKey } from '@shimmer-from-structure/vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'

import App from '@/App.vue'
import CarvisActionBar from '@/components/generic/CarvisActionBar.vue'
import CarvisAvatar from '@/components/generic/CarvisAvatar.vue'
import CarvisBadge from '@/components/generic/CarvisBadge.vue'
import CarvisButton from '@/components/generic/CarvisButton.vue'
import CarvisCheckbox from '@/components/generic/CarvisCheckbox.vue'
import CarvisChip from '@/components/generic/CarvisChip.vue'
import CarvisCombobox from '@/components/generic/CarvisCombobox.vue'
import CarvisDialog from '@/components/generic/CarvisDialog.vue'
import CarvisDivider from '@/components/generic/CarvisDivider.vue'
import CarvisDropdown from '@/components/generic/CarvisDropdown.vue'
import CarvisFlash from '@/components/generic/CarvisFlash.vue'
import CarvisForm from '@/components/generic/CarvisForm.vue'
import CarvisH1 from '@/components/generic/CarvisH1.vue'
import CarvisH2 from '@/components/generic/CarvisH2.vue'
import CarvisH3 from '@/components/generic/CarvisH3.vue'
import CarvisIcon from '@/components/generic/CarvisIcon.vue'
import CarvisImage from '@/components/generic/CarvisImage.vue'
import CarvisInput from '@/components/generic/CarvisInput.vue'
import CarvisLabel from '@/components/generic/CarvisLabel.vue'
import CarvisLink from '@/components/generic/CarvisLink.vue'
import CarvisModal from '@/components/generic/CarvisModal.vue'
import CarvisPlaceholder from '@/components/generic/CarvisPlaceholder.vue'
import CarvisPreview from '@/components/generic/CarvisPreview.vue'
import CarvisProgressBar from '@/components/generic/CarvisProgressBar.vue'
import CarvisQuote from '@/components/generic/CarvisQuote.vue'
import CarvisRangeSlider from '@/components/generic/CarvisRangeSlider.vue'
import CarvisSpinner from '@/components/generic/CarvisSpinner.vue'
import CarvisTable from '@/components/generic/CarvisTable.vue'
import CarvisTableSort from '@/components/generic/CarvisTableSort.vue'
import CarvisTabs from '@/components/generic/CarvisTabs.vue'
import CarvisText from '@/components/generic/CarvisText.vue'
import CarvisTextArea from '@/components/generic/CarvisTextArea.vue'
import CarvisTextField from '@/components/generic/CarvisTextField.vue'
import CarvisTile from '@/components/generic/CarvisTile.vue'
import CarvisToggle from '@/components/generic/CarvisToggle.vue'
import CarvisToolTip from '@/components/generic/CarvisToolTip.vue'
import CarvisUnitTextField from '@/components/generic/CarvisUnitTextField.vue'
import router from '@/router'
import sentryPlugin from '@/sentry/plugin'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.provide(shimmerConfigKey, {
  shimmerColor: '#d1d5db', // gray 300
  backgroundColor: '#e5e7eb', // gray 200
  duration: 1.5,
  fallbackBorderRadius: 8
})

app
  .component('CarvisActionBar', CarvisActionBar)
  .component('CarvisAvatar', CarvisAvatar)
  .component('CarvisFlash', CarvisFlash)
  .component('CarvisButton', CarvisButton)
  .component('CarvisCheckbox', CarvisCheckbox)
  .component('CarvisChip', CarvisChip)
  .component('CarvisCombobox', CarvisCombobox)
  .component('CarvisBadge', CarvisBadge)
  .component('CarvisDialog', CarvisDialog)
  .component('CarvisDivider', CarvisDivider)
  .component('CarvisDropdown', CarvisDropdown)
  .component('CarvisForm', CarvisForm)
  .component('CarvisH1', CarvisH1)
  .component('CarvisH2', CarvisH2)
  .component('CarvisH3', CarvisH3)
  .component('CarvisIcon', CarvisIcon)
  .component('CarvisImage', CarvisImage)
  .component('CarvisInput', CarvisInput)
  .component('CarvisLabel', CarvisLabel)
  .component('CarvisLink', CarvisLink)
  .component('CarvisModal', CarvisModal)
  .component('CarvisPlaceholder', CarvisPlaceholder)
  .component('CarvisPreview', CarvisPreview)
  .component('CarvisProgressBar', CarvisProgressBar)
  .component('CarvisQuote', CarvisQuote)
  .component('CarvisRangeSlider', CarvisRangeSlider)
  .component('CarvisSpinner', CarvisSpinner)
  .component('CarvisTable', CarvisTable)
  .component('CarvisTableSort', CarvisTableSort)
  .component('CarvisTabs', CarvisTabs)
  .component('CarvisText', CarvisText)
  .component('CarvisTextArea', CarvisTextArea)
  .component('CarvisTextField', CarvisTextField)
  .component('CarvisTile', CarvisTile)
  .component('CarvisToggle', CarvisToggle)
  .component('CarvisToolTip', CarvisToolTip)
  .component('CarvisUnitTextField', CarvisUnitTextField)
  .use(pinia)
  .use(router)
  .use(sentryPlugin)
  .use(autoAnimatePlugin)
  .use(PrimeVue, { unstyled: true })
  .mount('#app')
